import { render, staticRenderFns } from "./genjin_list.vue?vue&type=template&id=936bf6c2&scoped=true&"
import script from "./genjin_list.vue?vue&type=script&lang=js&"
export * from "./genjin_list.vue?vue&type=script&lang=js&"
import style0 from "./genjin_list.vue?vue&type=style&index=0&id=936bf6c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936bf6c2",
  null
  
)

export default component.exports